module.exports = __webpack_public_path__ + "static/media/kanmoshi_logo.f45445d5.png";